import { useDispatch } from 'react-redux';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';
import type { InjectedRouter } from 'react-router';
import RevisionActions from '../../../actions/RevisionActions';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { formatTimestamp } from '../../../utils';
import type { ProjectDashboardRevision } from '../projectDashboardTypes';
import styles from './IssueScanDropdown.module.less';

type Props = {
  revision: ProjectDashboardRevision;
  routerPush: InjectedRouter['push'];
};

const getScanButtonLabel = (scannedAt: string) => (
  <span className="full">Scanned: {formatTimestamp(scannedAt)}</span>
);

const renderRevisionScans = (revision: ProjectDashboardRevision) => revision?.data?.revisionScans?.map(revScan => (
  <MenuItem
    active={revScan.id === revision.data?.selectedRevisionScan?.id}
    eventKey={revScan.id}
    key={revScan.id}
  >
    Scanned: {formatTimestamp(revScan.scanned_at)}
  </MenuItem>
)) ?? [];

const IssueScanDropdown: VoidFunctionComponent<Props> = ({
  revision,
  routerPush,
}) => {
  const dispatch = useDispatch();

  const onSelect = (revisionScanId: number) => {
    RevisionActions.selectRevisionScan(revision?.data?.locator, revisionScanId);
    if (revisionScanId) {
      dispatch(IssuesV2Store.actions.setScanId(revisionScanId));
      routerPush({
        pathname: window.location.pathname,
        search: `?revisionScanId=${revisionScanId}`,
      });
    }
  };

  const isSelectedRevision = !!revision?.data?.selectedRevisionScan;
  const areThereRevisions = (revision?.data?.revisionScans?.length ?? 0) > 1;
  if (!isSelectedRevision && !areThereRevisions) {
    return null;
  }
  const selectedScannedAt = revision?.data?.selectedRevisionScan?.scanned_at;
  if (!selectedScannedAt) {
    return null;
  }
  return (
    <DropdownButton
      id="select-issue-scan"
      className={styles.dropdownButton}
      key={revision?.data?.selectedRevisionScan?.id}
      title={getScanButtonLabel(selectedScannedAt)}
      onSelect={onSelect as any}
    >
      {renderRevisionScans(revision)}
    </DropdownButton>
  );
};

export default IssueScanDropdown;
